import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-array/src/zip.js